import React from 'react';

import {
  PageWrapper,
  LoadingContainer,
  useNotification
} from '@sopranodesign/pulse-components';
import {
  Drivers,
  useQueryClient,
  useQuery,
  useMutation
} from '@sopranodesign/pulse-hooks';
import { useAuth } from '@sopranodesign/pulse-auth';

import { updateSemanticDriver } from '../api/index';

const SemanticSearchDrivers = () => {
  const { showSuccess } = useNotification();

  const { hasPermission } = useAuth();

  const queryClient = useQueryClient();

  const allQuery = useQuery({
    queryKey: [
      'semantic-search/all'
    ]
  });

  const currentQuery = useQuery({
    queryKey: [
      'semantic-search'
    ]
  });

  const mutation = useMutation({
    mutationFn: updateSemanticDriver
  });

  const handleDriver = async driver => {
    await mutation.mutateAsync(driver.id);
    await queryClient.invalidateQueries('semantic-search');
    showSuccess(
      `Successfully made ${driver.name} your semantic search provider.`
    );
  };

  const isLoading = allQuery.isLoading || currentQuery.isLoading;

  const copy = {
    available: {
      title: 'Available semantic search providers',
      info:
        'Choose a currently supported semantic search provider to power your chatbot.'
    },
    other: {
      title: 'Other semantic search providers Search',
      info: 'Let us know which semantic search provider you want to use next.'
    }
  };

  return (
    <PageWrapper
      header="Semantic search"
      subheader="Configure your chosen semantic search srovider">
      {isLoading && <LoadingContainer />}
      {!isLoading && (
        <Drivers
          copy={copy}
          type="single"
          required
          value={!isLoading && currentQuery.data?.data?.id}
          handleClick={handleDriver}
          drivers={allQuery.data.data}
          canEditDriver={() => false}
          canEnableDriver={() => hasPermission('edit nlp providers')}
          canDisableDriver={() => hasPermission('edit nlp providers')}
        />
      )}
    </PageWrapper>
  );
};

export default SemanticSearchDrivers;
